export class NumberUtils {

    // ===============================
    // 1. VALIDATION & NULL CHECKS
    // ===============================

    static isNull(input: number | null | undefined): boolean {
        return input == undefined || input == null;
    }

    static isNullOrZero(input: number | null | undefined): boolean {
        return input == undefined || input == null || input == 0;
    }

    static isNotNullAndNotZero(input: number | null | undefined): boolean {
        return input !== null && input !== undefined && input !== 0;
    }

    static isGreaterThanZero(input: number | null | undefined): boolean {
        return input !== null && input !== undefined && input > 0;
    }

    static isNotGreaterThanZero(input: number | null | undefined): boolean {
        return input === null || input === undefined || input <= 0;
    }

    static isEven(num: number): boolean {
        return num % 2 === 0;
    }

    static isOdd(num: number): boolean {
        return num % 2 !== 0;
    }

    // ===============================
    // 2. TYPE CONVERSION
    // ===============================

    static toBoolean(input: number | null | undefined): boolean {
        return input !== null && input !== undefined && input == 1;
    }
    static toBooleanOrNull(input: number | null | undefined): boolean | null {
        if (input === null || input === undefined) {
            return null;
        }
        return input == 1 ? true : input == 0 ? false : null;
    }

    // ===============================
    // 3. MATH OPERATIONS
    // ===============================

    static round(num: number, decimals: number): number {
        const factor = Math.pow(10, decimals);
        return Math.round(num * factor) / factor;
    }

    static random(min: number, max: number): number {
        if (isNaN(min) || isNaN(max)) {
            throw new Error("Error: Only numbers are accepted as arguments.");
        }
        // Force base 10 parsing to avoid issues with base 8 versus base 10
        return Math.floor(
            Math.random() *
            (parseInt(max.toString(), 10) - parseInt(min.toString(), 10) + 1) +
            parseInt(min.toString(), 10)
        );
    }

    static clamp(num: number, min: number, max: number): number {
        return Math.min(Math.max(num, min), max);
    }

    // ===============================
    // 4. FORMATTING & DISPLAY
    // ===============================

    static thousandsSeparator(num: number): string {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    static formatCurrency(num: number, decimals: number = 2, currencySymbol: string = '₺'): string {
        const formattedNumber = NumberUtils.round(num, decimals).toFixed(decimals);
        return `${this.thousandsSeparator(parseFloat(formattedNumber))} ${currencySymbol}`;
    }

    static toPercentage(num: number, decimals: number = 2): string {
        return `${NumberUtils.round(num * 100, decimals)}%`;
    }

    static parseInt(input: string | null | undefined): number {
        return parseInt(input ?? '0', 10);
    }
} 